module.exports = __webpack_public_path__ + "images/createListImage.3552982e.svg";